import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {MobileDrawer, Text} from 'wix-ui-tpa/cssVars'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {useAppSelector} from '../../../../hooks/runtime'
import {getLegendItems} from '../../../../selectors/seating/legend'
import {CloseButton} from '../../common/close-button'
import {LegendItem} from '../plan/legend/item'
import {PricesOverlayProps} from './interfaces'
import {classes} from './prices-overlay.st.css'

export const PricesOverlay = ({pricesOverlayOpen, onClose}: PricesOverlayProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney, getTicketPriceText} = useCurrencyFormatter()

  const legendItems = useAppSelector(state => getLegendItems(state, t, {getTicketPriceText, getFormattedMoney}))

  return (
    <MobileDrawer isOpen={pricesOverlayOpen} onRequestClose={onClose}>
      <div className={classes.container}>
        <div className={classes.header}>
          <Text tagName="h2" className={classes.title}>
            {t('seatingMapModal_prices_title')}
          </Text>
          <CloseButton small className={classes.closeButton} closeButtonAsButton={false} closeModal={onClose} />
        </div>
        <div className={classes.list}>
          {legendItems.map(({color, price, name}, index) => (
            <LegendItem key={index} color={color} price={price} name={name} />
          ))}
        </div>
      </div>
    </MobileDrawer>
  )
}
